import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Box } from "../../box/src";
import { CATEGORIES, FontAwesomeIcon } from "../../font-awesome-icon/src";
import { useTheme } from "../../theme/src";
export const SuccessMessage = ({ color, iconColor = 'grass', mt = 2, text, }) => {
    const theme = useTheme();
    const iconExclamationMarkColor = theme.colors[iconColor] || iconColor;
    return (_jsxs(SuccessWrapper, { "data-testid": "ds-success-message", mt: mt, children: [_jsx(Box, { flexShrink: 0, children: _jsx(FontAwesomeIcon, { color: iconExclamationMarkColor, height: "20px", iconName: "circle-check", iconType: CATEGORIES.SOLID }) }), _jsx(Box, { color: color, ml: 2, style: Object.assign({}, (color ? {} : { color: 'inherit' })), children: text })] }));
};
const SuccessWrapper = styled(Box).attrs(() => ({
    alignItems: 'center',
    color: 'grass',
})) ``;
//# sourceMappingURL=SuccessMessage.js.map